import { useCallback, useState } from "react"
import SnackBar from 'components/SnackBar';

const defaultSnackbar = {
  isOpen: false,
  text: '',
  type: 'success',
}

const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState(defaultSnackbar);

  const openSnackbar = (type, text) => setSnackbar({ isOpen: true, type, text });
  const closeSnackbar = () => setSnackbar({ ...snackbar, isOpen: false });

  const renderSnackbar = useCallback(() => (
    <SnackBar closeSnackbar={closeSnackbar} {...snackbar} />
  ), [snackbar])
  
  return {
    snackbar,
    openSnackbar,
    closeSnackbar,
    renderSnackbar,
  }
};

export default useSnackbar;